export default {
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    },
    full: {
      type: Boolean,
      required: false
    },
    outline: {
      type: Boolean,
      required: false
    },
    outlinePrimary: {
      type: Boolean,
      required: false
    },
    secondary: {
      type: Boolean,
      required: false
    }
  }
}
